import { useRef, useContext, useEffect } from "react";
import styled from "styled-components/macro";
import Routes from "Routes";
import { AppState } from "./State";

export default function Container() {
  const initialScrollableRef = useRef();

  const [{ scrollableRef }, dispatch] = useContext(AppState);

  useEffect(() => {
    if (scrollableRef) return;

    dispatch({ type: "Set Scrollable Ref", ref: initialScrollableRef });
    //eslint-disable-next-line
  }, [scrollableRef]);

  return (
    <Wrapper>
      <ContentWidth ref={scrollableRef}>
        <Routes />
      </ContentWidth>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 61px;
  overflow: auto;
  @media print {
    overflow: visible;
    position: relative;
    bottom: auto;
  }
`;

const ContentWidth = styled.div`
  max-width: 1220px;
  min-height: 100%;
  margin: 0 auto;
  position: relative;
`;
